import { useMemo, useState } from "react";
import { cn } from "@/utils";

interface UserAvatarProps {
  name?: string;
  imageUrl?: string | null;
  onClick?: () => void;
  className?: string;
}

export const UserAvatar = ({
  name,
  imageUrl,
  onClick,
  className,
}: UserAvatarProps) => {
  const initials = useMemo(() => {
    const names = name?.split(" ") ?? [];
    const initials = names.map((n) => n[0]).join("");
    return initials.length > 2 ? initials.substring(0, 2) : initials;
  }, [name]);

  const [isError, setIsError] = useState(false);

  return (
    <div
      className={cn(
        "flex h-9 w-9 shrink-0 cursor-default items-center justify-center rounded-full bg-surface-disabled text-sm",
        onClick && "hover:bg-secondary cursor-pointer",
        className,
      )}
      onClick={onClick}
    >
      {imageUrl && !isError ? (
        <img
          className="h-full w-full rounded-full object-cover"
          src={imageUrl}
          alt="Profile Avatar"
          onError={() => setIsError(true)}
        />
      ) : (
        <span className="text-white">{initials ?? "--"}</span>
      )}
    </div>
  );
};
